exports.DESKTOP_LIMIT = 10;
exports.MOBILE_LIMIT = 5;



// WEBPACK FOOTER //
// ./src/constants/charts.js